import { Popover, Typography } from '@mui/material';

interface IHistoryBtnPopOverProps {
  openHover: boolean;
  hoverAnchorEl: HTMLElement | null;
  handlePopoverClose(): void;
}

export const HistoryButtonPopOver = ({ openHover, hoverAnchorEl, handlePopoverClose }: IHistoryBtnPopOverProps) => (
  <Popover
    disableRestoreFocus
    id="mouse-over-popover"
    sx={{ pointerEvents: 'none' }}
    open={openHover}
    anchorEl={hoverAnchorEl}
    anchorOrigin={{
      vertical: 'center',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'center',
      horizontal: 'right',
    }}
    onClose={handlePopoverClose}
  >
    <Typography sx={{ p: 1 }}>Recently Closed Tabs</Typography>
  </Popover>
);
